import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const RadioButtonChecked = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 18 18">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.99994 0.507813C7.32034 0.507798 5.67844 1.00586 4.28191 1.939C2.88537 2.87215 1.79691 4.19847 1.15418 5.75023C0.511448 7.30199 0.343314 9.00951 0.671039 10.6568C0.998763 12.3042 1.80763 13.8173 2.99534 15.0049C4.18305 16.1925 5.69627 17.0013 7.34362 17.3288C8.99097 17.6564 10.6985 17.4881 12.2502 16.8453C13.8019 16.2024 15.1281 15.1138 16.0611 13.7172C16.9942 12.3206 17.4921 10.6787 17.4919 8.99905C17.4894 6.74769 16.5939 4.58927 15.0018 2.99738C13.4098 1.4055 11.2513 0.510157 8.99994 0.507813Z" fill="currentColor"/>
      <circle cx="8.99935" cy="9.00033" r="3.33333" fill="#FDFDFD"/>
    </SvgIcon>
  );
};

export default RadioButtonChecked;
